// Generated by Melange

import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

const _map = {"s":"s","m":"m"};

function sizeToJs(param) {
  return param;
}

function sizeFromJs(param) {
  return _map[param];
}

const _map$1 = {"default":"default","white":"white"};

function kindToJs(param) {
  return param;
}

function kindFromJs(param) {
  return _map$1[param];
}

function make(sizeOpt) {
  const size = sizeOpt !== undefined ? sizeOpt : "m";
  return function (kindOpt) {
    const kind = kindOpt !== undefined ? kindOpt : "default";
    return function (className) {
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("div", {
                        className: Cn.fromList({
                              hd: "loadingspinner",
                              tl: {
                                hd: size === "s" ? "w-4 h-4 border-2" : "w-8 h-8 border-4",
                                tl: {
                                  hd: kind === "default" ? "border-gray-300 text-blue-500" : "border-transparent text-white",
                                  tl: {
                                    hd: Cn.take(className),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            })
                      }),
                  className: "h-full w-full flex justify-center items-center"
                });
    };
  };
}

function LoadingSpinner(Props) {
  return Curry._1(make(Props.size)(Props.kind), Props.className);
}

const make$1 = LoadingSpinner;

export {
  sizeToJs ,
  sizeFromJs ,
  kindToJs ,
  kindFromJs ,
  make$1 as make,
}
/* react/jsx-runtime Not a pure module */
